import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { Check } from 'react-feather';
import { Col, Row } from 'reactstrap';

import theme from 'constants/theme';
import { parseHtml } from 'helpers';

const MTPchoiceResult = ({ result }) => {
  const listYourAnswer = result?.resultAnswers;

  return (
    <div>
      {result?.data?.map((item, index) => {
        const isYourAnswer = listYourAnswer?.[index];

        return (
          <Row key={index} noGutters className="my-1">
            <Col sm={1}>
              {isYourAnswer && <Check id="success" color={theme.success} />}
            </Col>
            <Col sm={11} className="multi-result-survay">
              <span className={classnames(isYourAnswer && 'bold')}>
                {parseHtml(item)}
              </span>
            </Col>
          </Row>
        );
      })}
    </div>
  );
};

MTPchoiceResult.propTypes = {
  result: PropTypes.object.isRequired,
};

export default MTPchoiceResult;
